
























































import { Vue } from "vue-property-decorator";
interface AppState {
  currentYear: Number;
}
export default Vue.extend({
  data() {
    const initialState: AppState = {
      currentYear: new Date().getFullYear()
    };
    return initialState;
  }
});
